module.exports = __webpack_public_path__ + "static/media/IQ.4cc30714.svg";